<template>
  <section
    v-if="blok && blok.video_url"
    v-editable="blok"
    :class="[classObjects, videoSize, hasSpacing, animationClasses]"
    class="theme-light"
  >
    <div :class="blok.size === 'fullscreen' ? '' : 'container'">
      <div :class="blok.size === 'fullscreen' ? '' : 'row'">
        <div :class="`article-video__content ${getGridClassName(blok.size)}`">
          <div
            v-if="blok.video_poster && blok.video_poster.length && inactive"
            class="article-video__poster icon icon--play"
            @click="startVideo"
          >
            <component
              :is="'a_imageSource' | dashify"
              :blok="blok.video_poster[0]"
              :image-url="blok.video_poster[0].image"
              alt="poster"
              modifier-class="article-video__poster-image"
            />
          </div>
          <video ref="videoRef" class="article-video__video" muted controls>
            <source :src="blok.video_url" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleVideo',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    animateWhenVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      inactive: true,
      animationClass: '',
    }
  },
  computed: {
    classObjects() {
      return {
        'is-full-height': this.blok.isFullHeight,
      }
    },
    hasSpacing() {
      return `space--${this.blok.space}`
    },
    videoSize() {
      return `article-video--${this.blok.size}`
    },
    animationClasses() {
      return `article-video${this.animationClass}`
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.autoStartVideo()
        this.animationClass =
          ' article-video--animate article-video--animate-in'
      } else {
        this.animationClass =
          ' article-video--animate article-video--animate-done'
      }
    },
  },
  mounted() {
    if (this.animateWhenVisible) {
      this.animationClass = ' article-video--animate'
    }
  },
  methods: {
    getGridClassName: (align) => {
      if (align === 'small') {
        return 'col-12 col-md-9 col-lg-6'
      }
      return 'col-12'
    },
    autoStartVideo() {
      const playPromise = this.$refs.videoRef.play()
      if (playPromise !== null && playPromise !== undefined) {
        playPromise.then(() => {
          this.$refs.videoRef.play()
          this.inactive = false
        })
        playPromise.catch(() => {
          if (!this.blok.video_poster || !this.blok.video_poster.length) {
            this.inactive = false
          }
        })
      }
    },
    startVideo() {
      this.$refs.videoRef.play()
      this.inactive = false
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.article-video {
  position: relative;

  &--animate {
    .article-video__content {
      opacity: 0;
      transform: scale(0.7);
      transition: all 0.3s ease-out 0.2s;
    }
    &-done {
      .article-video__content {
        opacity: 1;
        transform: scale(1);
      }
    }
    &-in {
      .article-video__content {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  &__content {
    margin: 0;
    padding: 0;
    position: relative;
    overflow: hidden;
  }

  &__video {
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
  }

  &--small {
    .article-video__content {
      margin-right: auto;
      margin-left: auto;
    }
  }

  &__poster {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    cursor: pointer;

    &:hover {
      &.icon {
        &::before {
          color: $white;
          text-shadow: 0 0 1px $black;
        }
      }
    }

    &.icon {
      &::before {
        color: $black;
        position: absolute;
        top: calc(50% - 35px);
        left: calc(50% - 35px);
        font-size: 70px;
        z-index: 2;
        text-shadow: 0 0 1px $white;
      }
    }
  }

  &__poster-image {
    width: 100%;
  }
}
</style>
